var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.402,
    height: 11.402,
    viewBox: "0 0 11.402 11.402",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;stroke:#909090;}.b{stroke-linecap:round;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.5 -1.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M2,13.121c0-1.471,0-2.207.457-2.664S3.65,10,5.121,10H9.282c1.471,0,2.207,0,2.664.457s.457,1.193.457,2.664,0,2.207-.457,2.664-1.193.457-2.664.457H5.121c-1.471,0-2.207,0-2.664-.457S2,14.592,2,13.121Z",
    transform: "translate(0 -3.839)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M12,14v2.08",
    transform: "translate(-4.799 -5.759)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M6,6.161V5.121a3.121,3.121,0,1,1,6.241,0v1.04",
    transform: "translate(-1.92)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.c25e0acdfd19730c25ae337f94d91b70.svg";
export { ForwardRef as ReactComponent };